import React from 'react'
import { Layout, Typography, Space, Button } from 'antd'
import { DatabaseOutlined, BarChartOutlined } from '@ant-design/icons'

const { Header } = Layout
const { Title } = Typography

const AppHeader: React.FC = () => {
  return (
    <Header 
      style={{ 
        background: '#fff', 
        padding: '0 24px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}
    >
      <Space align="center">
        <DatabaseOutlined style={{ fontSize: '24px', color: '#1890ff' }} />
        <Title level={3} style={{ margin: 0, color: '#1890ff' }}>
          标准知识图谱数智化系统
        </Title>
      </Space>
      
      <Space>
        <Button 
          type="primary" 
          icon={<DatabaseOutlined />}
          href="/skg/kg"
        >
          知识图谱
        </Button>
        <Button 
          icon={<BarChartOutlined />}
          href="/skg/stats"
        >
          统计报表
        </Button>
      </Space>
    </Header>
  )
}

export default AppHeader
